import React, { useMemo } from 'react';
import styled from 'styled-components';

import {
  useAbstractEditor,
  List as PermissionList,
  connect as connectPermissions
} from 'components/Permissions';
import SliderItem from './SliderItem';
import { translations } from 'i18n';

const EditorContainer = styled.div`
  ${({ theme }) => theme.PermissionList}
`;

const PermissionsEditor = ({ app, permissions, onChange }) => {
  const {
    comms: { permissions: permissionsText }
  } = translations;

  const {
    permissions: localPermissions,
    visiblePermissions,
    setPermission,
    setAllPermissions
  } = useAbstractEditor({ app, permissions, onChange });

  const areAllPermissionsOn = useMemo(() => {
    for (const name of visiblePermissions) {
      if (localPermissions[name] === false) {
        return false;
      }
    }
    return true;
  }, [visiblePermissions, localPermissions]);

  return (
    <EditorContainer>
      <SliderItem
        checked={areAllPermissionsOn}
        hideBottomBorder={true}
        item={{
          description: permissionsText._toggle_all.description(),
          isNew: true,
          title: permissionsText._toggle_all.label(),
          value: 'toggle-all'
        }}
        onChange={() => setAllPermissions(!areAllPermissionsOn)}
      />
      <PermissionList
        containerComponent="div"
        itemComponent={SliderItem}
        newPermissions={app.newPermissions}
        permissions={localPermissions}
        permissionAlerts={app.osPermissionsEnableableMap}
        visiblePermissions={visiblePermissions}
        onChange={setPermission}
      />
    </EditorContainer>
  );
};

export default connectPermissions(PermissionsEditor);
